import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/marketing/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import FeaturesList from "../components/marketing/FeaturesList";
import Benefits from "../components/marketing/Benefits";
import Cta from "../components/marketing/Cta";
import Testimonials from "../components/marketing/Testimonials";

const Marketing = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <FeaturesList />
      <Benefits />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default Marketing;
